/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContributionPreset {
  RECOMMENDED = 'RECOMMENDED',
  INDUSTRY = 'INDUSTRY',
  CURRENT = 'CURRENT',
  COMPLIANT = 'COMPLIANT',
  GENEROUS = 'GENEROUS',
  NONE = 'NONE',
}
